import { contact } from "./site";

export const contactBlock = {
  type: "contact",
  company: contact.legalName,
  address: ["D-46, Vibhuti Khand, Gomtinagar", "Lucknow, Uttar Pradesh – 226010", "India"],
  email: contact.email,
  phone: contact.phone,
  cin: contact.cin,
  gstin: contact.gst,
};

export const cookiePolicy = {
  title: "Cookie Policy",
  updated: "14 September 2026",
  heroCopy:
    "This Cookie Policy explains how Bytevora IT Solutions Private Limited uses cookies and similar technologies on its website, what purposes they serve, and how you can manage your preferences.",
  intro: [
    "This Cookie Policy explains how Bytevora IT Solutions Private Limited (“Bytevora”, “we”, “us”, or “our”) uses cookies and similar technologies when you visit our website.",
    "Cookies can help websites function properly, remember preferences, understand how visitors use a website, and support certain third-party features.",
    "The specific cookies used on the Bytevora website may change as our website, services, and technology evolve. Where required, we will provide appropriate choices regarding non-essential cookies.",
  ],
  sections: [
    {
      id: "what-are-cookies",
      title: "What Are Cookies?",
      blocks: [
        { type: "p", text: "Cookies are small text files that websites may place on your device when you visit them." },
        { type: "p", text: "They can store information about your browser, preferences, session, or interactions with a website." },
        { type: "p", text: "Some cookies are necessary for a website to function correctly, while others may be used for analytics, preferences, security, or third-party functionality." },
        { type: "p", text: "Similar technologies may include local storage, session storage, pixels, tags, and other browser-based technologies that perform related functions." },
      ],
    },
    {
      id: "how-we-use-cookies",
      title: "How We Use Cookies",
      blocks: [
        { type: "p", text: "Bytevora may use cookies and similar technologies to:" },
        {
          type: "list",
          items: [
            "Operate and secure the website",
            "Maintain essential website functionality",
            "Remember user preferences",
            "Understand website performance and usage",
            "Improve user experience",
            "Support forms and security features",
            "Integrate third-party services where required",
          ],
        },
        { type: "p", text: "We aim to use only the cookies and technologies reasonably necessary for the operation, improvement, and functionality of our website." },
      ],
    },
    {
      id: "types-of-cookies",
      title: "Types of Cookies We May Use",
      blocks: [
        { type: "h3", text: "Strictly Necessary Cookies" },
        { type: "p", text: "These cookies are required for the website to function properly and cannot generally be disabled through our cookie preference controls." },
        { type: "p", text: "They may be used for:" },
        {
          type: "list",
          items: ["Security", "Session management", "Form protection", "Cookie consent preferences", "Core website functionality"],
        },
        { type: "p", text: "These cookies do not require consent where applicable law permits them to be used as strictly necessary." },
        { type: "h3", text: "Preference Cookies" },
        { type: "p", text: "Preference cookies help the website remember choices you make, such as language, display preferences, or cookie settings." },
        { type: "p", text: "These cookies may improve convenience but are not always essential to the core operation of the website." },
        { type: "h3", text: "Analytics Cookies" },
        { type: "p", text: "Bytevora may use analytics cookies to understand how visitors interact with the website, such as which pages are visited, how users navigate the site, and whether technical issues occur." },
        { type: "p", text: "Analytics information may help us improve website performance, usability, and content." },
        { type: "p", text: "Where required by applicable law, analytics cookies will only be enabled after you provide consent." },
        { type: "h3", text: "Functional / Third-Party Cookies" },
        { type: "p", text: "Certain website features may rely on third-party services that place cookies or use similar technologies." },
        { type: "p", text: "Examples may include:" },
        {
          type: "list",
          items: ["Embedded media", "Maps", "Chat tools", "Analytics services", "Payment-related tools", "Authentication services", "Social media integrations"],
        },
        { type: "p", text: "These cookies are controlled partly or entirely by the relevant third-party provider." },
        { type: "h3", text: "Advertising / Marketing Cookies" },
        { type: "p", text: "Bytevora does not intend to use advertising or marketing cookies unless such technologies are introduced for legitimate marketing activities in the future." },
        { type: "p", text: "If advertising or marketing cookies are introduced, we will update this Cookie Policy and, where required, request consent before enabling them." },
        {
          type: "table",
          headers: ["Cookie / Technology", "Provider", "Purpose", "Category", "Duration"],
          rows: [
            ["Cookie consent preference", "Bytevora", "Stores the visitor’s cookie choices", "Necessary", "As configured"],
            ["Session / security cookie", "Bytevora", "Supports security and session functionality", "Necessary", "Session / limited duration"],
            ["Analytics cookie", "Third-party, if enabled", "Measures website usage and performance", "Analytics", "Provider-defined"],
          ],
        },
      ],
    },
    {
      id: "third-party-services",
      title: "Third-Party Services",
      blocks: [
        { type: "p", text: "Some features of our website may rely on third-party services." },
        { type: "p", text: "These providers may use their own cookies or similar technologies in accordance with their respective privacy and cookie policies." },
        { type: "p", text: "Bytevora does not directly control cookies placed by third parties." },
        { type: "p", text: "Where relevant, third-party services may include providers of:" },
        {
          type: "list",
          items: ["Website analytics", "Hosting and infrastructure", "Payment services", "Embedded content", "Maps", "Communication tools", "Security services"],
        },
        { type: "p", text: "We recommend reviewing the privacy and cookie policies of any third-party provider whose services you choose to use." },
      ],
    },
    {
      id: "your-cookie-choices",
      title: "Your Cookie Choices",
      blocks: [
        { type: "p", text: "When you first visit our website, you may be shown a cookie notice that allows you to accept, reject, or manage non-essential cookies." },
        { type: "p", text: "Strictly necessary cookies may remain active because they are required for the operation, security, or functionality of the website." },
        { type: "p", text: "You can change your cookie preferences at any time through the Cookie Preferences control available on this website." },
      ],
    },
    {
      id: "managing-cookies",
      title: "Managing Cookies Through Your Browser",
      blocks: [
        { type: "p", text: "Most browsers allow you to view, block, delete, or limit cookies through browser settings." },
        { type: "p", text: "Please note that blocking certain cookies may affect the functionality or usability of some parts of the website." },
        { type: "p", text: "Browser controls vary by provider, so refer to your browser’s help or privacy settings for specific instructions." },
      ],
    },
    {
      id: "browser-privacy-signals",
      title: "Browser Privacy Signals",
      blocks: [
        { type: "p", text: "Some browsers or extensions may send privacy preference signals, such as “Do Not Track” or Global Privacy Control." },
        { type: "p", text: "The way websites and service providers respond to these signals may vary depending on applicable law, browser support, and technical implementation." },
        { type: "p", text: "Where legally required and technically supported, Bytevora may honor applicable privacy preference signals." },
      ],
    },
    {
      id: "information-collected",
      title: "Information Collected Through Cookies",
      blocks: [
        { type: "p", text: "Depending on the cookies enabled, information collected may include technical and usage information such as browser type, device information, session identifiers, pages visited, interaction data, referral source, and cookie preferences." },
        {
          type: "p",
          segments: [
            { t: "Cookie-related information will be handled in accordance with our " },
            { link: "Privacy Policy", to: "/privacy-policy" },
            { t: "." },
          ],
        },
      ],
    },
    {
      id: "cookie-duration",
      title: "How Long Cookies Remain",
      blocks: [
        { type: "p", text: "Cookies may be either:" },
        { type: "p", segments: [{ t: "Session Cookies", strong: true }, { t: " — deleted when you close your browser." }] },
        { type: "p", segments: [{ t: "Persistent Cookies", strong: true }, { t: " — remain on your device for a defined period or until removed." }] },
        { type: "p", text: "The exact duration depends on the purpose of the cookie and the service placing it." },
      ],
    },
    {
      id: "changes",
      title: "Changes to This Cookie Policy",
      blocks: [
        { type: "p", text: "We may update this Cookie Policy from time to time to reflect changes in our website, technology, cookies, third-party services, business practices, or legal requirements." },
        { type: "p", text: "The latest version will be published on this page with an updated revision date." },
        { type: "p", text: "We encourage visitors to review this page periodically." },
      ],
    },
    {
      id: "contact-us",
      title: "Contact Us",
      blocks: [
        { type: "p", text: "If you have questions about this Cookie Policy or our use of cookies and similar technologies, please contact:" },
        contactBlock,
      ],
    },
  ],
};

export const disclaimer = {
  title: "Disclaimer",
  updated: "14 September 2026",
  heroCopy:
    "The information available on this website is provided for general informational and business purposes only. By accessing or using this website, you acknowledge and agree to the terms of this Disclaimer.",
  intro: [
    "Welcome to the website of Bytevora IT Solutions Private Limited (“Bytevora”, “we”, “us”, or “our”).",
  ],
  sections: [
    {
      id: "general-information",
      title: "General Information",
      blocks: [
        { type: "p", text: "Bytevora provides information about its technology capabilities, services, solutions, business activities, and related topics through this website." },
        { type: "p", text: "While we make reasonable efforts to keep the information accurate, current, and complete, we do not guarantee that all content on the website will always be free from errors, omissions, inaccuracies, or outdated information." },
        { type: "p", text: "Website content may be modified, updated, removed, or expanded at any time without prior notice." },
      ],
    },
    {
      id: "no-professional-advice",
      title: "No Professional or Legal Advice",
      blocks: [
        { type: "p", text: "Information published on this website should not be considered legal, financial, accounting, regulatory, tax, investment, or other professional advice." },
        { type: "p", text: "Any technical information, recommendations, articles, examples, or general guidance provided by Bytevora are intended for informational purposes only." },
        { type: "p", text: "You should obtain appropriate professional advice where required before making decisions based on information available through this website." },
      ],
    },
    {
      id: "technology-and-service-information",
      title: "Technology and Service Information",
      blocks: [
        { type: "p", text: "Descriptions of our services, capabilities, technologies, solutions, processes, or potential outcomes are provided for general reference." },
        { type: "p", text: "Actual project scope, functionality, architecture, technology stack, timelines, deliverables, pricing, performance, support arrangements, and other terms may vary depending on the specific requirements of each engagement." },
        { type: "p", text: "No content on this website should be interpreted as a binding offer, quotation, guarantee, or contractual commitment unless expressly confirmed through a separate written agreement, proposal, statement of work, or contract issued by Bytevora." },
      ],
    },
    {
      id: "no-guarantee-of-results",
      title: "No Guarantee of Results",
      blocks: [
        { type: "p", text: "Technology projects and digital services may involve variables outside Bytevora’s reasonable control." },
        { type: "p", text: "Accordingly, we do not guarantee specific:" },
        {
          type: "list",
          items: ["Business results", "Revenue outcomes", "Search rankings", "User growth", "Conversion rates", "Cost savings", "Operational improvements", "Software performance levels", "Availability levels", "Security outcomes", "Commercial success"],
        },
        { type: "p", text: "unless such obligations are expressly stated in a written agreement between Bytevora and the relevant client." },
      ],
    },
    {
      id: "emerging-technologies",
      title: "Software, Cloud, AI, and Emerging Technologies",
      blocks: [
        { type: "p", text: "Software systems, cloud infrastructure, artificial intelligence, automation, machine learning, APIs, and third-party technologies may contain limitations, errors, dependencies, or risks." },
        { type: "p", text: "AI-generated or automated outputs may not always be accurate, complete, current, or suitable for every use case and may require human review." },
        { type: "p", text: "Bytevora does not represent that any technology solution will be completely free from bugs, interruptions, vulnerabilities, compatibility issues, or third-party service dependencies." },
        { type: "p", text: "Specific service commitments, if applicable, will be governed by the relevant contract or service agreement." },
      ],
    },
    {
      id: "third-party-services",
      title: "Third-Party Services and Platforms",
      blocks: [
        { type: "p", text: "Our services or website may reference, integrate with, or depend on third-party products and services, including but not limited to:" },
        {
          type: "list",
          items: ["Cloud providers", "Hosting providers", "Payment gateways", "APIs", "Software libraries", "SaaS platforms", "Analytics services", "Communication tools", "Artificial intelligence services", "Open-source software"],
        },
        { type: "p", text: "Bytevora does not control such third parties and is not responsible for their availability, policies, pricing, security, functionality, changes, outages, or actions." },
        { type: "p", text: "Use of third-party products or services may also be subject to their own terms, privacy policies, licences, and conditions." },
      ],
    },
    {
      id: "external-links",
      title: "External Links",
      blocks: [
        { type: "p", text: "This website may contain links to websites or services operated by third parties." },
        { type: "p", text: "These links are provided for convenience or reference only." },
        { type: "p", text: "The presence of an external link does not necessarily constitute an endorsement, partnership, sponsorship, or recommendation by Bytevora." },
        { type: "p", text: "We are not responsible for the content, accuracy, security, privacy practices, or availability of third-party websites." },
        { type: "p", text: "You access external websites at your own discretion and risk." },
      ],
    },
    {
      id: "website-availability",
      title: "Website Availability",
      blocks: [
        { type: "p", text: "We make reasonable efforts to maintain the availability and proper functioning of this website." },
        { type: "p", text: "However, we do not guarantee uninterrupted or error-free access." },
        { type: "p", text: "The website may occasionally become unavailable due to:" },
        {
          type: "list",
          items: ["Maintenance", "Server issues", "Network problems", "Security incidents", "Third-party outages", "Technical failures", "Events beyond our reasonable control"],
        },
        { type: "p", text: "Bytevora will not be liable solely because the website is temporarily unavailable." },
      ],
    },
    {
      id: "security",
      title: "Security",
      blocks: [
        { type: "p", text: "Bytevora takes reasonable measures to maintain the security of its website and systems." },
        { type: "p", text: "However, no website, network, communication system, or internet transmission can be guaranteed to be completely secure." },
        { type: "p", text: "Users are responsible for taking appropriate precautions when using the internet, including protecting their devices, accounts, credentials, and personal information." },
      ],
    },
    {
      id: "intellectual-property",
      title: "Intellectual Property",
      blocks: [
        { type: "p", text: "Unless otherwise stated, the content available on this website, including text, branding, graphics, interfaces, layouts, visual elements, documentation, and original materials, is owned by or licensed to Bytevora IT Solutions Private Limited and may be protected by applicable intellectual property laws." },
        { type: "p", text: "Third-party names, logos, trademarks, software, and other intellectual property remain the property of their respective owners." },
        { type: "p", text: "Reference to third-party technologies or brands does not imply ownership, endorsement, or affiliation unless expressly stated." },
      ],
    },
    {
      id: "testimonials-and-examples",
      title: "Testimonials, Case Studies, and Examples",
      blocks: [
        { type: "p", text: "Where Bytevora publishes testimonials, case studies, project examples, demonstrations, illustrations, or hypothetical use cases, they should not be interpreted as a guarantee that another customer or project will achieve identical results." },
        { type: "p", text: "Results depend on numerous factors, including project requirements, implementation conditions, business environment, technology choices, resources, and client participation." },
      ],
    },
    {
      id: "pricing-and-commercial-information",
      title: "Pricing and Commercial Information",
      blocks: [
        { type: "p", text: "Any pricing, package, rate, estimate, or commercial information displayed on this website is subject to change unless confirmed through a formal written quotation or agreement." },
        { type: "p", text: "Final project pricing may depend on factors including:" },
        {
          type: "list",
          items: ["Scope", "Complexity", "Timelines", "Integrations", "Infrastructure", "Licensing", "Third-party services", "Support requirements", "Custom development needs"],
        },
        { type: "p", text: "Taxes and third-party charges may apply where applicable." },
      ],
    },
    {
      id: "limitation-of-liability",
      title: "Limitation of Liability",
      blocks: [
        { type: "p", text: "To the maximum extent permitted by applicable law, Bytevora shall not be responsible for any indirect, incidental, special, consequential, or similar loss arising solely from reliance on general information published on this website or from the use or inability to use this website." },
        { type: "p", text: "Where a separate contract exists between Bytevora and a customer, liability relating to the services provided will be governed by the terms of that agreement." },
        { type: "p", text: "Nothing in this Disclaimer is intended to exclude or limit liability where such exclusion or limitation is prohibited by applicable law." },
      ],
    },
    {
      id: "changes",
      title: "Changes to This Disclaimer",
      blocks: [
        { type: "p", text: "We may update this Disclaimer periodically to reflect changes in our website, services, business practices, or legal requirements." },
        { type: "p", text: "The latest version will be published on this page with the updated revision date." },
        { type: "p", text: "Continued use of the website after an update constitutes acknowledgement of the revised Disclaimer." },
      ],
    },
    {
      id: "contact-us",
      title: "Contact Us",
      blocks: [
        { type: "p", text: "If you have any questions regarding this Disclaimer, please contact:" },
        contactBlock,
      ],
    },
  ],
};
